import axios from 'axios';
import uuidv4 from 'uuid/v4';
import loadImage from 'blueimp-load-image';
import Util from './Util';
import {Mutex} from 'await-semaphore';

const TOKEN_EXPIRE_MARGIN = 1 * 1000 * 60; // [ms]

let original_transform = loadImage.transform;
loadImage.transform = function(img, options, callback, file, data) {
	if((options.maxHeight === undefined && options.maxWidth === undefined && options.orientation === undefined) ||
		(img.width < options.maxWidth && img.height < options.maxHeight)) {
		callback(undefined);
	}else{
		original_transform(img, options, callback, file, data);
	}
}

export default class ConoHa {
	constructor(datasetManager) {
		this.datasetManager = datasetManager;
		this.conoha_user_token = null;
		this.mutex_token = new Mutex();
	}
	
	async validateConoHaUserToken () {
		return this.mutex_token.use(async () => {
			if(!this.isExpiredConoHaUserToken())
				return this.conoha_user_token;
			
			this.conoha_user_token = await this.datasetManager.getConoHaUserToken();
			
			return this.conoha_user_token;
		});
	}
	
	isExpiredConoHaUserToken () {
		if(this.conoha_user_token === null)
			return true;
		
		let expired = Util.getUTCFromYMDHMS(this.conoha_user_token.expires);
		let today = Date.now();
		
		return expired < (today + TOKEN_EXPIRE_MARGIN);
	}
	
	async upload (file, headers, obj_name) {
		if(await this.validateConoHaUserToken() === null)
			throw new Error("token error");
		
		if (obj_name === undefined)
			obj_name = uuidv4();
		let url = this.conoha_user_token.endpoints.image_upload + '/' + obj_name;
		let config = {headers: {
			'X-Auth-Token': this.conoha_user_token.id,
		}};
		if(headers !== undefined)
			Object.assign(config.headers, headers);
		
		return await axios
			.put(url, file, config).then(() => {
				return { 
					src: url,
					obj_name: obj_name,
				};
			}).catch((e) => {
				throw new Error(e);
			});
	}
	
	async delete (obj_name) {
		if( await this.validateConoHaUserToken() === null)
			throw new Error("token error");
		
		let url = this.conoha_user_token.endpoints.image_upload + '/' + obj_name;
		let config = {headers: {'X-Auth-Token': this.conoha_user_token.id}};
		
		return await axios
			.delete(url, config).then(() => {
				return "delete success";
			}).catch((e) => {
				throw new Error(e);
			});
	}

	async deleteByURI (uri) {
		if( await this.validateConoHaUserToken() === null)
			throw new Error("token error");
		
		let url = uri;
		let config = {headers: {'X-Auth-Token': this.conoha_user_token.id}};
		
		return await axios
			.delete(url, config).then(() => {
				return "delete success";
			}).catch((e) => {
				throw new Error(e);
			});
	}

	async generateImage (file, max_size) {
		if (max_size === undefined)
			throw new Error("max size not set");
		
		return new Promise(function(resolve, reject) {
			loadImage.parseMetaData(file, function (data) {
				let orientation;
				if (data.exif)
					orientation = data.exif.get('Orientation');
				let options = {
					canvas: true,
				};
				if(orientation !== undefined && orientation !== 1)
					options.orientation = orientation;
				
				if (max_size.WIDTH > 0 && max_size.HEIGHT > 0) {
					options.maxHeight = max_size.HEIGHT;
					options.maxWidth = max_size.WIDTH;
				}
				loadImage(file, function (canvas) {
					
					if (canvas === undefined) {
						let reader = new FileReader();
						reader.onload = function (e) {
							resolve({
								blob: file,
								url: e.target.result,
							});
						}
						reader.readAsDataURL(file);
					} else if(canvas.type === "error") {
						reject("Error loading image " + file.name);
					} else {
						let url = canvas.toDataURL(file.type, 0.85);
						let barr, bin, i, len;
						bin = atob(url.split('base64,')[1]);
						len = bin.length;
						barr = new Uint8Array(len);
						i = 0;
						while (i < len) {
							barr[i] = bin.charCodeAt(i);
							i++
						}
						let blob = new Blob([barr], {type: file.type});
						resolve({
							blob: blob,
							url: url,
						});
					}
					
				}, options);
			});
		});
	}
}
